import React from 'react';
import { observer } from 'mobx-react';
import { Form, Input, FormGroup } from 'components/Form';
import Button from 'components/Button';
import Link from 'components/Link';
import TagSelect from '../../components/TagSelect';
import DocumentTypeSelect from '../../components/DocumentTypeSelect';
import RequirePerms from 'iam/containers/RequirePerms';
import styles from './InfoForm.m.sass';
var InfoForm = function InfoForm(_ref) {
  var view = _ref.view,
    showArchived = _ref.showArchived,
    buttonText = _ref.buttonText,
    buttonDataTest = _ref.buttonDataTest,
    showTags = _ref.showTags;
  var canEdit = !view.document || view.document.canEdit;
  return /*#__PURE__*/React.createElement(Form, {
    className: styles.form,
    onSubmit: view.save
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Title",
    field: "title",
    model: view,
    placeholder: "Give your document a name",
    readOnly: !canEdit,
    disabled: !canEdit || view.save.pending
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Description",
    field: "description",
    model: view,
    placeholder: "Optional",
    readOnly: !canEdit,
    disabled: !canEdit || view.save.pending
  }), showTags && /*#__PURE__*/React.createElement(FormGroup, {
    label: "Tags"
  }, /*#__PURE__*/React.createElement(TagSelect, {
    documentTagStore: view.rootStore.documentTagStore,
    value: view.tags.slice(),
    onChange: view.setTags,
    placeholder: "Select tags that apply to this document",
    disabled: !canEdit || view.save.pending
  })), !showTags && /*#__PURE__*/React.createElement(FormGroup, {
    label: "Document type"
  }, /*#__PURE__*/React.createElement(DocumentTypeSelect, {
    documentTypeStore: view.rootStore.documentTypeStore,
    value: view.documentType,
    onChange: function onChange(opt) {
      return view.setDocumentType(opt);
    },
    disabled: !view.canChangeDocumentType,
    uploader: "CLIENT"
  })), view.confirmationRequired && /*#__PURE__*/React.createElement(FormGroup, {
    label: "Confirm"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    label: view.confirmationText,
    field: "confirmationGranted",
    model: view
  }))), (canEdit || view.canRemove) && /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, view.canRemove && /*#__PURE__*/React.createElement(RequirePerms, {
    rootStore: view.rootStore,
    anyOf: ['DOCS_SELF_REMOVE', 'DOCS_CLIENT_REMOVE', 'DOCS_PROVIDER_REMOVE']
  }, /*#__PURE__*/React.createElement(Link, {
    className: styles.removeButton,
    onClick: view.remove
  }, "Remove")), canEdit && /*#__PURE__*/React.createElement(Button, {
    className: styles.saveButton,
    loading: view.save.pending,
    disabled: view.saveEnabled || view.save.pending,
    submit: true,
    "data-test": buttonDataTest
  }, buttonText)));
};
export default observer(InfoForm);
//# sourceMappingURL=index.js.map
